<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Tipo</th>
          <th scope="col">Código</th>
          <th scope="col">Diagnóstico</th>
          <th scope="col">Descripción</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plandiag in datosPaginados" :key="plandiag.idPlanDiag">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(plandiag.idPlanDiag)" title="Editar">edit_square</i></td>
          <td>{{descTipoDiag(plandiag.tipo)}}</td>
          <td>{{plandiag.diagnosticoCodigo}}</td>
          <td>{{plandiag.diagnosticoNombre}}</td>
          <td>{{plandiag.observacion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePlanDiag(plandiag.idPlanDiag)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
<!-- Botón Lista de Valores  Diagnostico -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-10">
                    <label for="idDiagnostico" class="form-label">Diagnóstico</label>
                    <select class="form-control" id="idDiagnostico" name="idDiagnostico" v-model="datoPlanDiag.idDiagnostico">
                      <option v-for="diagnostico in diagnosticos" :value="diagnostico.idDiagnostico" :key="diagnostico.idDiagnostico">
                        {{ diagnostico.codigo }} - {{ diagnostico.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-2">
                    <label for="tipo" class="form-label">Tipo</label>
                    <select class="form-control" id="tipo" name="tipo" v-model="datoPlanDiag.tipo" required>
                      <option value="P">Presuntivo</option>
                      <option value="D">Definitivo</option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Diagnostico -->
<!-- Botón Lista de Valores  Interconsulta -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idInterconsulta" class="form-label"> Interconsulta</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoPlanDiag.idInterconsulta">
                      <option v-for="interconsulta in interconsultas" :value="interconsulta.idInterconsulta" :key="interconsulta.idInterconsulta">
                        {{ interconsulta.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
<!-- Botón Lista de Valores  Interconsulta -->
            <div class="mb-3">
              <div class="row">
                <div class="col-12">
                  <label for="observacion" class="form-label">Descripción</label>
                  <textarea class="form-control" id="observacion" name="observacion" v-model="datoPlanDiag.observacion" style='text-transform:uppercase' required></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlanDiag" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlanDiag" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import { decodificarTipoDiag } from '@/modules/decode.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  data () {
    return {
      plandiags : [],
      datoPlanDiag : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      diagnosticos: [],
      interconsultas: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.p_idInterconsulta = this.$route.params.p_idinterconsulta
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchDiagnosticos()
    this.fetchInterconsultas()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.plandiags.length / this.elementosPorPagina)
    },
    descTipoDiag(codigo){
      return decodificarTipoDiag(codigo);
    },
/*    
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwplandiags/nombre/'+this.nombreBusqueda).then(response=>{
          this.plandiags=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.plandiags.slice(ini,fin);
        });
      }
    },
*/
    getDataPaginaTodos(noPagina){
      api.get('/vwplandiags/idinterconsulta/'+this.p_idInterconsulta).then(response=>{
      this.plandiags=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.plandiags.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idDiagnostico'
        ,'tipo'
        ,'observacion'
      ];
      const requiredFieldsText = [
        'idDiagnostico'
        ,'tipo'
        ,'observacion'
      ];
      return validarForm(this.datoPlanDiag, requiredFields, requiredFieldsText);
    },
    async guardarPlanDiag(){
      if(this.validarForm() === 1){
        try {
          this.datoPlanDiag.idInterconsulta = this.p_idInterconsulta;
          await api.post('/plandiags', this.datoPlanDiag)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PlanDiag creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlanDiag(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plandiags', this.datoPlanDiag)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "PlanDiag creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPlanDiag={}
      this.titulo   = 'Crear Plan Diagnóstico'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idPlanDiag){
      this.modalWindow = true
      if(idPlanDiag != null){    
           api.get('/vwplandiags/'+idPlanDiag).then(resp=>{
          this.datoPlanDiag = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Plan Diagnóstico'
      this.btnCrear = false
      this.btnEditar= true
    },
    async deletePlanDiag (idPlanDiag) {
      try{
        await api.delete('/plandiags/'+idPlanDiag)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchDiagnosticos() {
      fetch('http://localhost:8080/api/v1/diagnosticos')
        .then(response => response.json())
        .then(data => {
          this.diagnosticos = data;
        })
        .catch(error => {
          console.error('Error fetching diagnosticos:', error);
        });
    },
    fetchInterconsultas() {
      fetch('http://localhost:8080/api/v1/interconsultas')
        .then(response => response.json())
        .then(data => {
          this.interconsultas = data;
        })
        .catch(error => {
          console.error('Error fetching interconsultas:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
